import {AxiosResponse} from "axios";
import {Response} from "./dto/Response";
import apiJson from "../config/api-json";

export class TokenAPI {

    baseUrl = 'email'

    async verifyToken(token: string): Promise<string> {
        const response: AxiosResponse<Response<string>> = await apiJson.put(`${this.baseUrl}/verify-token/${token}`, undefined)
        if (response.status !== 200) {
            throw new Error(response.statusText)
        }
        return response.data.data
    }

}